import React from "react";
import tradingBg from '../assets/img/tradingbg2.png'

export default function FourthHome() {
    return (
        <div className="fourth-home">
            <style>{`
                :root {
                    --primary: #16a34a;
                    --muted: #6b7280;
                    --bg: none;
                    --card: #1A2028;
                    --radius: 12px;
                }
                .company-title {
                    text-align: center;
                    width: 100%;
                    font-size: 2.5rem;
                    color: var(--primary);
                    position: relative;
                    bottom: 50px;
                }
                .fourth-home {
                    font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI",
                        Roboto, "Helvetica Neue", Arial;
                    color: #111827;
                    background: var(--bg);
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .container {
                    width: 100%;
                    max-width: 1200px;
                    padding: 32px;
                    box-sizing: border-box;
                }

                header.site-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 16px;
                    margin-bottom: 24px;
                }

                .brand {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    text-decoration: none;
                    color: inherit;
                }

                .brand .logo {
                    width: 44px;
                    height: 44px;
                    border-radius: 10px;
                    background: linear-gradient(135deg, var(--primary), #0f8b3b);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-weight: 700;
                    box-shadow: 0 4px 14px rgba(22,163,74,0.18);
                }

                nav.site-nav {
                    display: flex;
                    gap: 20px;
                    align-items: center;
                }

                nav.site-nav a {
                    color: var(--muted);
                    text-decoration: none;
                    padding: 8px 12px;
                    border-radius: 8px;
                    transition: color .15s, background .15s;
                }

                nav.site-nav a.cta {
                    background: var(--primary);
                    color: white;
                }

                /* Hero */
                .hero {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 32px;
                    align-items: center;
                    margin-bottom: 40px;
                }

                .hero .copy h1 {
                    font-size: 2.25rem;
                    margin: 0 0 12px 0;
                    line-height: 1.05;
                    color: #0f172a;
                }

                .hero .copy p {
                    margin: 0 0 20px 0;
                    color: var(--muted);
                    font-size: 1rem;
                }

                .hero .actions {
                    display: flex;
                    gap: 12px;
                    flex-wrap: wrap;
                }

                .btn {
                    padding: 10px 16px;
                    border-radius: 10px;
                    border: none;
                    cursor: pointer;
                    font-weight: 600;
                }

                .btn.primary {
                    background: var(--primary);
                    color: white;
                }

                .btn.ghost {
                    background: transparent;
                    color: var(--primary);
                    border: 1px solid rgba(22,163,74,0.12);
                }

                .hero-visual {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .card {
                    background: var(--card);
                    border-radius: var(--radius);
                    box-shadow: 0 6px 18px rgba(15,23,42,0.06);
                    padding: 18px;
                }

                /* Features */
                .features {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 18px;
                    margin-bottom: 40px;
                }

                .feature {
                    display: flex;
                    gap: 12px;
                    align-items: flex-start;
                }

                .feature .icon {
                    width: 46px;
                    height: 46px;
                    border-radius: 10px;
                    background: linear-gradient(180deg, rgba(22,163,74,0.12), rgba(22,163,74,0.06));
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--primary);
                    flex-shrink: 0;
                }

                .feature h3 {
                    margin: 0 0 6px 0;
                    font-size: 1.02rem;
                    color: #bbbbbbff;
                }

                .feature p {
                    margin: 0;
                    color: var(--muted);
                    font-size: 0.95rem;
                }

                /* Footer */
                footer.site-footer {
                    width: 100%;
                    border-top: 1px solid rgba(15,23,42,0.04);
                    padding: 20px 0 40px;
                    margin-top: auto;
                }

                .footer-inner {
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    align-items: center;
                    flex-wrap: wrap;
                    color: var(--muted);
                }

                /* Responsive */
                @media (max-width: 980px) {
                    .hero {
                        grid-template-columns: 1fr;
                        text-align: left;
                    }
                    .features {
                        grid-template-columns: repeat(2, 1fr);
                    }
                    nav.site-nav {
                        display: none;
                    }
                }

                @media (max-width: 640px) {
                    .container {
                        padding: 20px;
                    }
                    header.site-header {
                        margin-bottom: 16px;
                    }
                    .hero .copy h1 {
                        font-size: 1.6rem;
                    }
                    .features {
                        grid-template-columns: 1fr;
                    }

                    /* make the about paragraph larger on small viewports */
                    #about p { font-size: 3.5vw !important; }

                    /* make the About Our Company h2 larger on small viewports */
                    #about .card h2 { font-size: 7vw !important; }
                }
            `}</style>

            <div className="container">
                <div className="company-title">
                    <h1>Our Company</h1>
                    <p style={{ marginTop: 10, fontSize: 15, color: "var(--muted)" }}>
                        Small team, big impact. Meet the people building product and supporting customers.
                    </p>
                </div>
                <main>
                    <section className="hero" aria-labelledby="hero-heading">
                        <div className="copy">
                            <h1 id="hero-heading">Innovation, Reliability, Service — Choose Us</h1>
                            <p>
                                We provide innovative, reliable solutions backed by exceptional service, empowering your business to grow confidently with modern technology, seamless performance, and support.
                            </p>

                            <div className="actions">
                                <button className="btn primary">Get Started</button>
                                <button className="btn ghost">Learn More</button>
                            </div>
                        </div>

                        <div className="hero-visual">
                            <div className="card" style={{ width: "100%", maxWidth: 520 }}>
                                <img src={tradingBg} />
                            </div>
                        </div>
                    </section>

                    <section id="features" className="features" aria-label="Features">
                        <div className="feature card">
                            <div className="icon" aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="4" r="2" stroke="currentColor" strokeWidth="1.6" />
                                    <circle cx="5" cy="18" r="2" stroke="currentColor" strokeWidth="1.6" />
                                    <circle cx="19" cy="18" r="2" stroke="currentColor" strokeWidth="1.6" />
                                    <path d="M12 6v4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                    <path d="M12 10.5L6.5 15.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                    <path d="M12 10.5L17.5 15.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                </svg>
                            </div>
                            <div>
                                <h3>Scalable Architecture</h3>
                                <p>Designed to grow: microservices-ready patterns and cloud-first infrastructure.</p>
                            </div>
                        </div>
                        <div className="feature card">
                            <div className="icon" aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 3v6l4 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
                                </svg>
                            </div>
                            <div>
                                <h3>Reliable Performance</h3>
                                <p>Fast load times and consistent uptime with optimized resources and caching.</p>
                            </div>
                        </div>

                        <div className="feature card">
                            <div className="icon" aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.6" />
                                    <path d="M8 12h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                </svg>
                            </div>
                            <div>
                                <h3>Secure by Default</h3>
                                <p>Built-in best practices for authentication, authorization, and data protection.</p>
                            </div>
                        </div>
                    </section>

                    <section id="about" style={{ marginBottom: 36 }}>
                        <div className="card" style={{ padding: 20 }}>
                            <h2 style={{ marginTop: 0, color: "#bbbbbbff" }}>About Our Company</h2>
                            <br/>
                            <p style={{ color: "var(--muted)", width: "92%", fontSize: "1.25vw", lineHeight: 1.6 }}>
                               At SwiftEx, we bring innovation and trust together in the world of cryptocurrency trading. Our mission is to make digital asset trading simple, secure, and profitable for everyone — from beginners to experienced investors.
<br/>
<br/>
We operate through a network of professional trading agents, ensuring every client receives personalized support and real-time guidance. Whether you’re looking to buy, sell, or expand your crypto portfolio, our agents are here to help you make informed decisions based on market insights and proven strategies.
<br/>
With cutting-edge technology, transparent operations, and a strong commitment to customer success, we aim to create a seamless bridge between people and the fast-evolving world of crypto finance.
<br/>
<br/>
At SwiftEx, trading isn’t just about numbers — it’s about partnership, expertise, and growth.
                            </p>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}